/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-16 15:26:55
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Button } from '@shopify/polaris';
import PlanLimitModal from 'src/components/views/common/confirm-modal';
import ActionChoosePackage from 'src/components/views/subscription-v4/package/action-choose-package';
import { PACKAGES_V4 } from 'src/constants/subscription';

import { getCorrectPlanV4 } from 'src/helpers/subscription-v3-helper';
import { routes } from 'src/routes';

import wavingHandIcon from 'src/assets/images/common/waving-hand-icon.png';

type Props = {
  totalCustomFilterTrees: number,
  data: Array,
  content: Object,
  feature: string,
  featureLimit: number,
  selectedPlan: string,
  planLimitModal: boolean,
  openPlanLimitModal: Function,
  correctPlan: Object,
  packagePlans: Object | Array,
  confirmationUrl: string
};

type ComposedProps = Props & WithI18nProps;

const ExceedFeatureNotify = (props: ComposedProps) => {
  const {
    content,
    feature,
    history,
    featureLimit,
    selectedPlan,
    planLimitModal,
    openPlanLimitModal,
    correctPlan,
    packagePlans,
    confirmationUrl,
    i18n
  } = props;
  const [packageRequest, setPackageRequest] = useState('basic');
  const [packageInfo, setPackageInfo] = useState({});
  const [activeLimitModal, setActiveLimitModal] = useState(false);
  const [requestOpen, setRequestOpen] = useState(false);

  useEffect(() => {
    // Set data package info
    let packageName = 'professional';
    if (_.isEmpty(selectedPlan) || selectedPlan.includes('basic')) {
      packageName = 'essential';
    }
    setPackageRequest(packageName);
    const findPackageInfo = PACKAGES_V4.find(element => element.name === packageName);
    setPackageInfo(findPackageInfo);
  }, [selectedPlan]);

  useEffect(() => {
    // Redirect to shopify confirmation page
    if (confirmationUrl) {
      window.top.location.href = confirmationUrl;
      return;
    }
  }, [confirmationUrl]);

  // const handleUpgradeNow = () => {
  //   setActiveLimitModal(false);
  //   setRequestOpen(true);
  //   if (openPlanLimitModal) {
  //     openPlanLimitModal(false);
  //   }
  // };

  const handleCloseWarningModal = () => {
    setActiveLimitModal(false);
    if (openPlanLimitModal) openPlanLimitModal(false);
  };

  // Render text warning upgrade plan
  const renderText = () => {
    if (selectedPlan.includes('basic') || _.isEmpty(selectedPlan)) {
      return content['basic'];
    }
    if (
      selectedPlan.includes('professional') &&
      feature === 'merchandising' &&
      content['professional']
    ) {
      return content['professional'];
    }
    return content['essential'];
  };

  const actionUpgrade = () => {
    history.push(routes.subscription.package());
  };

  if (featureLimit < 0) return null;

  const products = correctPlan?.products || 1000;
  return (
    <>
      <div className="exceed-feature-notify exceed-filter-notify">
        <p>
          <img alt="pfs-waving-hand" width={20} height={20} src={wavingHandIcon} />
          {renderText()}
        </p>
        {!(
          selectedPlan.includes('professional') &&
          feature === 'merchandising' &&
          content['professional']
        ) && (
          <Button onClick={() => actionUpgrade()}>
            {i18n.translate('AdminHTML.FilterTree.Plan.upgradeAction')}
          </Button>
        )}
      </div>
      {requestOpen && (
        <ActionChoosePackage
          packageInfo={packageInfo}
          products={parseInt(products)}
          packagePlans={packagePlans[packageRequest]}
          isSpecific={true}
          allPackagePlans={packagePlans}
          packageSelected={products}
          disabled={false}
          requestOpen={requestOpen}
          setRequestClose={() => setRequestOpen(false)}
        />
      )}
      <PlanLimitModal
        active={activeLimitModal || planLimitModal}
        handleCancel={() => handleCloseWarningModal()}
        handleConfirm={() => actionUpgrade()}
        title={i18n.translate(
          `AdminHTML.${
            feature === 'merchandising' ? 'MerchandisingV2' : 'FilterTree'
          }.Plan.modalTitle`
        )}
        content={i18n.translate(
          `AdminHTML.${
            feature === 'merchandising' ? 'MerchandisingV2' : 'FilterTree'
          }.Plan.modalContent`,
          {
            number: featureLimit
          }
        )}
        primaryActionContent={i18n.translate(
          `AdminHTML.${
            feature === 'merchandising' ? 'MerchandisingV2' : 'FilterTree'
          }.Plan.modalAction`
        )}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const packagePlans = _.get(state.subscriptionV3, 'packagePlans', {});
  const chargeInfo = _.get(state.subscriptionV3, 'invoice.chargeInfo', {});
  const currentTotalProducts = _.get(tenantApp, 'appParams.currentTotalProducts');
  const selectedPlan =  _.get(state.oauth.tenantApp, 'selectedPlan', '');
    // Get correct plan
  const correctPlan = getCorrectPlanV4(chargeInfo, packagePlans, currentTotalProducts, selectedPlan);
  return {
    tenantApp,
    selectedPlan,
    currentTotalProducts: _.get(tenantApp, 'appParams.currentTotalProducts'),
    confirmationUrl: _.get(state.subscriptionV3, 'confirmationUrl', ''),
    packagePlans,
    correctPlan
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ExceedFeatureNotify));
